import ApiHelper from "./CoreHelpers/ApiHelper";

export const DEFAULT_FILTER_ORDER_WEIGHT = 99999;

export const FILTER_ORDER_WEIGHTS = {
  trend_status: 99,
  ticker_as_link: 100,
  ticker: 100,
  type: 200,
  name: 200,
  status: 300,
  market: 300,
  tag: 400,
  state: 401
};

export const FILTER_KIND = {
  RADIO: "radio",
  VALUES: "values",
  DYNAMIC_AUTOCOMPLETE: "dynamic_autocomplete",
  SEARCH: "search",
  RANGE: "range"
};

export function getFilterOrderWeight(column) {
  const attributeName = column?.attribute_name;

  if (
    typeof attributeName === "string" &&
    Object.prototype.hasOwnProperty.call(FILTER_ORDER_WEIGHTS, attributeName)
  ) {
    return FILTER_ORDER_WEIGHTS[attributeName];
  }

  return DEFAULT_FILTER_ORDER_WEIGHT;
}

export function sortFilterColumnsByWeight(columns) {
  return columns
    .map((column, index) => ({ column, index }))
    .sort((a, b) => {
      const weightDiff =
        getFilterOrderWeight(a.column) - getFilterOrderWeight(b.column);

      if (weightDiff !== 0) {
        return weightDiff;
      }

      return a.index - b.index;
    })
    .map(({ column }) => column);
}

export function getFilterKind(column) {
  if (ApiHelper.getIsFilterableByRadio(column)) {
    return FILTER_KIND.RADIO;
  }

  if (
    ApiHelper.getIsFilterableByValueSet(column) ||
    ApiHelper.getIsFilterableByRuleset(column)
  ) {
    return FILTER_KIND.VALUES;
  }

  if (ApiHelper.getIsDynamicAutocomplete(column)) {
    return FILTER_KIND.DYNAMIC_AUTOCOMPLETE;
  }

  if (ApiHelper.getIsSearchable(column)) {
    return FILTER_KIND.SEARCH;
  }

  if (ApiHelper.getIsFilterableByRange(column)) {
    return FILTER_KIND.RANGE;
  }

  return null;
}

export function getOrderedFilterableColumns(columns, hasPermission) {
  const filterableColumns = (columns || []).filter(column => {
    if (!column || !getFilterKind(column)) {
      return false;
    }

    return ApiHelper.getUserHasPermissionToColumn(column, hasPermission);
  });

  return sortFilterColumnsByWeight(filterableColumns);
}
